module.exports = __webpack_public_path__ + "static/img/subway-thumb.0c9a050.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/subway-thumb.jpg
// module id = 41
// module chunks = 0